import React, { useState } from 'react';
import { X, Send } from 'lucide-react';
import api from '../utils/api';

export default function RequestModal({ onClose }) {
  const [form, setForm] = useState({
    requester_name: '',
    requester_email: '',
    title: '',
    description: '',
    priority: 'medium',
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (field, value) => setForm(prev => ({ ...prev, [field]: value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!form.requester_name.trim() || !form.title.trim() || !form.description.trim()) {
      setError('Vui lòng điền đầy đủ thông tin bắt buộc');
      return;
    }
    setLoading(true);
    try {
      await api.submitRequest(form);
      setSuccess(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="modal-overlay" onClick={onClose}>
        <div className="modal modal-sm" onClick={e => e.stopPropagation()}>
          <div className="modal-body" style={{ textAlign: 'center', padding: 40 }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>✅</div>
            <div style={{ fontSize: 18, fontWeight: 700, marginBottom: 8 }}>Gửi yêu cầu thành công!</div>
            <div style={{ color: 'var(--text-secondary)', fontSize: 14 }}>
              Yêu cầu của bạn đã được ghi nhận. Tien Le sẽ xem xét và phản hồi sớm nhất có thể.
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-primary" onClick={onClose}>Đóng</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal modal-md" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <div className="modal-title">Gửi yêu cầu công việc</div>
          <button className="btn-icon" onClick={onClose}><X size={18} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 16 }}>
              Bạn muốn giao việc cho Tien Le? Điền thông tin bên dưới, yêu cầu sẽ được xem xét và chấp nhận.
            </p>

            {error && (
              <div style={{ padding: '10px 14px', background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.2)', borderRadius: 6, color: '#ef4444', fontSize: 13, marginBottom: 16 }}>
                {error}
              </div>
            )}

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Tên của bạn *</label>
                <input className="form-input" value={form.requester_name}
                  onChange={e => handleChange('requester_name', e.target.value)}
                  placeholder="Nguyễn Văn A" required autoFocus />
              </div>
              <div className="form-group">
                <label className="form-label">Email (tuỳ chọn)</label>
                <input className="form-input" type="email" value={form.requester_email}
                  onChange={e => handleChange('requester_email', e.target.value)}
                  placeholder="email@example.com" />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Tiêu đề yêu cầu *</label>
                <input className="form-input" value={form.title}
                  onChange={e => handleChange('title', e.target.value)}
                  placeholder="Tên công việc cần làm" required />
              </div>
              <div className="form-group">
                <label className="form-label">Mức độ ưu tiên</label>
                <select className="form-select" value={form.priority}
                  onChange={e => handleChange('priority', e.target.value)}>
                  <option value="high">Cao</option>
                  <option value="medium">Trung bình</option>
                  <option value="low">Thấp</option>
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Mô tả chi tiết *</label>
              <textarea className="form-textarea" rows={5} value={form.description}
                onChange={e => handleChange('description', e.target.value)}
                placeholder="Mô tả chi tiết yêu cầu công việc..." required />
            </div>
          </div>
          <div className="modal-footer">
            <button className="btn btn-ghost" type="button" onClick={onClose}>Huỷ</button>
            <button className="btn btn-primary" type="submit" disabled={loading}>
              <Send size={15} /> {loading ? 'Đang gửi...' : 'Gửi yêu cầu'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
